var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-fade-spinner",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},_vm._l((_vm.count),function(n){return _c('span',{key:n,staticClass:"dot",style:(_vm.getDotStyle(n))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }